<div class="w-343 tablet:w-768 laptop:w-912 tablet:px-6" *ngIf="referee">
  <div class="referee-card grid grid-cols-1 pr-7 pl-6 py-7" [ngStyle]="{ 'border-left': '6px solid ' + borderColours[index%9] }">
    <div class="pb-6 border-neutral-100 border-b-1">
      <div class="grid grid-cols-1 tablet:grid-cols-2">
        <div class="flex justify-between">
          <div class="flex items-center">
            <div class="initial-circle" [ngStyle]="{ 'background-color': borderColours[index%9] }">
              <p class="initial-circle-inner">{{referee.firstName?.substring(0,1)?.toUpperCase()}}{{referee.lastName?.substring(0,1)?.toUpperCase()}}</p>
            </div>
            <div class="flex flex-col justify-center ml-2 pl-1 pt-0 mt-0">
              <p class="name font-medium">{{referee.firstName}} {{referee.lastName}}</p>
              <div class="flex items-center justify-start">
                <p class="reference-type whitespace-nowrap">{{referenceTypes[this.referenceType]}} Reference</p>
                <button class="tooltip-subject tooltip-manual-reference reference-info flex self-end" type="button" *ngIf="referee.referenceType === ReferenceTypes.Personal">
                  <i class="fak fa-information referee-type-info"></i>
                  <div class="tooltip w-310 bottom-8 left-MINUS143">
                    <div class="tooltip-content text-left text-3 leading-20">
                      A personal reference can be provided by someone who knows you outside of a work environment and can vouch for your character and skills.
                    </div>
                  </div>
                </button>
                <button class="tooltip-subject tooltip-manual-reference reference-info flex self-end" type="button" *ngIf="referee.referenceType === ReferenceTypes.Professional">
                  <i class="fak fa-information referee-type-info"></i>
                  <div class="tooltip w-310 bottom-8 left-MINUS143">
                    <div class="tooltip-content text-left text-3 leading-20">
                      A professional reference can be supplied from someone who has detailed information on your employment from an organisation where you have worked or are currently working.
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div class="visible tablet:invisible justify-self-end" *ngIf="status === RefereeStatus.ReferenceRequested">
            <button class="cancel w-44 h-44" (click)="onEditDetails()">
              <img src="/assets/talos-edit.svg" class="h-6" />
            </button>
          </div>
        </div>
        <div class="button-holder tablet:justify-self-end pt-4 tablet:pt-2">
          <button class="requested w-164 h-32" *ngIf="status === RefereeStatus.ReferenceRequested && !referee.refereeLastViewed">Reference Requested</button>
          <button class="requested-viewed tooltip-subject w-180 h-32" *ngIf="status === RefereeStatus.ReferenceRequested && referee.refereeLastViewed">Reference Requested
            <i class="fak fa-eye-on pl-1 text-5 align-middle"></i>
            <div class="tooltip w-200 bottom-9 opacity-100 left-eye">
              <div class="tooltip-content text-left">
                <p class="tooltip-header">Referee Last Seen</p>
                <p class="paragraph-1">{{referee.refereeLastViewed}}</p>
              </div>
            </div>
          </button>
          <button class="completed w-167 h-32 flex items-center justify-center" *ngIf="status === RefereeStatus.ReferenceCompleted">Reference Completed</button>
        </div>
      </div>
    </div>
    <div class="flex gap-6 justify-between align-center mt-1 pt-6 tablet:pt-7">
      <div class="flex">
        <div class="grid grid-cols-1 gap-6 tablet:grid-cols-2 align-center">
          <div class="flex flex-col justify-start pr-8 pb-2 tablet:pb-0 w-295 tablet:w-200">
            <i class="fak fa-talos-user icon"></i>
            <p><span class="bottom-title py-2">Referee Details</span></p>
            <p class="pb-1" *ngIf="referee.emailAddress"><a [href]="'mailto:' + referee.emailAddress" target="_blank" class="email text-4 text-info-200">{{truncate(referee.emailAddress, 35)}}</a></p>
            <p class="bottom-text">{{referee.contactNumber}}</p>
          </div>

          <div class="flex flex-col justify-start" *ngIf="referee.referenceType === ReferenceTypes.Professional">
            <i class="fak fa-talos-building icon"></i>
            <p><span class="bottom-title py-2">Organisation details</span></p>
            <p class="bottom-text pb-1">{{referee.jobTitle}} at {{referee.organisationName}}</p>
            <p class="bottom-text" *ngIf="referee.startDateMonth">
              {{months[referee.startDateMonth]}} {{referee.startDateYear}} - {{getEndDateString()}}</p>
          </div>

          <div class="flex flex-col justify-start" *ngIf="referee.referenceType === ReferenceTypes.Personal">
            <i class="fak fa-talos-calendar-alt icon"></i>
            <p><span class="bottom-title py-2">Time known</span></p>
            <p class="bottom-text flex items-center">{{referenceTimePeriods[timeKnown]}}</p>
          </div>

        </div>
      </div>
      <div class="pr-1 invisible tablet:visible" *ngIf="status === RefereeStatus.ReferenceRequested">
        <button class="cancel w-44 h-44" (click)="onEditDetails()">
          <img src="/assets/talos-edit.svg" class="h-6" />
        </button>
      </div>
    </div>
  </div>
</div>
